<template>
	<div v-if="pdfPreview.show" class="page_preview hide-scrollbar" style="overflow-y:scroll"
		:class="pdfPreview.show ? pdfPreview.confirm ? 'confirm show' : 'show' : ''">
		<a-icon type="close" class="close_button cursor-pointer text-white text-xl"
			@click="$store.commit('CLOSE_PREVIEW')" />
		<div class="pdf-viewer-wrap">
			<iframe id="fileIframe" loading="lazy"></iframe>
			<div v-if="!isTransactionCreated" class="pdf-toolbar-mask" aria-hidden="true"></div>
		</div>
		<div class="page-preview-action dF jSB aC px-8 w-full" style="margin-top: auto;">
			<a-button size="large" @click="$store.commit('CLOSE_PREVIEW')">Back</a-button>
			<a-alert type="info" show-icon class="mx-3" v-if="showFileWarning">
				<template #message>
					<div>
						Please ensure your document is under <strong>25 MB</strong> and no more than <strong>2,000
							pages</strong>;
					</div>
					<div>
						otherwise file will fail to send due to size restrictions.
						<a class="link"
							href="https://support.docusign.com/s/document-item?language=en_US&bundleId=gbo1643332197980&topicId=akk1578456465691.html&_LANG=enus"
							target="_blank">
							Check here for more details.
						</a>
					</div>
					<div>
						Current file size: <strong>{{ pdfFileSize }}</strong>
					</div>
				</template>
			</a-alert>
			<a-button type="primary" size="large" @click="$store.commit('PAGE_PREVIEW_CALLBACK')">
				{{ buttonText }}
			</a-button>
		</div>
	</div>
</template>

<script>
import { formatFileSize } from 'bh-mod'

export default {
	data() {
		return {
			pdf: null,
			pdfFileSize: null,
			isTransactionCreated: false
		}
	},
	computed: {
		pdfPreview() {
			return this.$store.state.appData.pdfPreview
		},
		buttonText() {
			const { buttonText, save, confirm, isManual } = this.pdfPreview;
			if (buttonText) return buttonText;
			if (save && confirm) return 'SAVE DOCUMENT';
			return isManual ? 'CREATE TRANSACTION' : 'SEND CONTRACT';
		},
		manualFile() {
			return this.pdfPreview.file;
		},
		showFileWarning() {
			return this.pdf?.size && (this.pdf.size / 1000) > 25000
		}
	},
	watch: {
		manualFile(val) {
			if (val) {
				this.updateIframeSrc("fileIframe", val);
			}
		},
		'pdfPreview.show'(val) {
			if (val) {
				this.getFileSize();
				this.isTransactionCreated = window.location.href.includes('/transaction/');
			}
		}
	},
	methods: {
		async getFileSize() {
			const { url } = this.pdfPreview;
			if (url) {
				this.$store.commit('LOAD', true);
				try {
					const response = await fetch(url);
					const blob = await response.blob();
					this.pdf = blob;
					this.pdfFileSize = formatFileSize(blob.size / 1000);
					this.updateIframeSrc("fileIframe", this.pdf);
				} catch (error) {
					console.error('Error fetching file size:', error);
					this.pdfFileSize = null;
				} finally {
					this.$store.commit('LOAD', false);
				}
			} else if (this.manualFile) {
				this.pdfFileSize = formatFileSize(this.manualFile.size / 1000);
			}
		},
		updateIframeSrc(iframeId, file) {
			this.$nextTick(() => {
				const frameElement = document.getElementById(iframeId);
				if (frameElement) {
					frameElement.src = window.URL.createObjectURL(file);
				}
			});
		}
	}
}
</script>

<style lang="scss">
.page_preview {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .6);
	display: flex;
	z-index: 1005;
	opacity: 0;
	pointer-events: none;
	transition: opacity .3s ease-out;
	justify-content: center;
	align-items: center;

	&.show {
		opacity: 1;
		pointer-events: all;
	}

	.close_button {
		position: absolute;
		top: 20px;
		right: 20px;
	}

	canvas,
	iframe,
	.pdf-viewer-wrap {
		width: 100%;
		flex: 1;
	}

	&:not(.confirm) {
		.page-preview-action {
			display: none;
		}

		canvas,
		iframe,
		.pdf-viewer-wrap {
			width: 100%;
			height: 90%;
		}
	}

	&.confirm {
		flex-direction: column;
		background: white;

		.close_button {
			display: none;
		}

		iframe,
		canvas {
			box-shadow: 0 2px 30px rgba(100, 100, 100, 0.3);
		}
	}
}

.page-preview-action {
	height: 100px;
}

/*
  The native browser PDF viewer inside the iframe cannot be customized to hide
  individual toolbar buttons. To prevent users from clicking the built-in
  Download/Print controls while keeping zoom/page controls usable, we place a
  small mask over the top-right area of the iframe where those buttons live.
*/
.pdf-viewer-wrap {
	position: relative;
}

.pdf-viewer-wrap iframe {
	width: 100%;
	height: 100%;
	display: block;
}

.pdf-toolbar-mask {
    position: absolute;
    top: 6px;
    right: 6px;
    height: 55px; /* approximate native viewer toolbar height */
    width: 215px; /* cover print/download/more without touching zoom */
    /* transparent by default to avoid visual differences with close button */
    background: #3c3c3c;
    pointer-events: auto; /* block interactions beneath */
    z-index: 2;
	/* prevent users from clicking the native toolbar buttons */
	cursor: not-allowed;
}

/* ensure the close button remains clickable above the mask */
.page_preview .close_button {
	z-index: 3;
}
</style>
